export enum SeniorTabsType {
  SystemAdministrator_Statistics = 'system-administrator_statistics',
  SystemAdministrator_WithoutStatistics = 'system-administrator_without-statistics',
  ProfessionalCaregiver_Manager = 'professional-caregiver_manager',
  ProfessionalCaregiver_Administrator = 'professional-caregiver_administrator',
  ProfessionalCaregiver_Operator = 'professional-caregiver_operator',
}
